var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C20.8495 32 25.1947 29.8423 28.1288 26.4348H3.87122C6.8054 29.8423 11.1506 32 16 32Z",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 17.4442 0.1925 18.8431 0.551188 20.1739H31.4489C31.8075 18.8431 32 17.4442 32 16Z",
    fill: "#338AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27173 22.2608C1.58017 22.9856 1.94073 23.6826 2.34829 24.3477H29.6515C30.0591 23.6825 30.4197 22.9855 30.7282 22.2608H1.27173Z",
    fill: "#338AF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3323 10.0914L4.2063 8.71174L7.3323 7.33211L8.71186 4.20618L10.0914 7.33211L13.2174 8.71174L10.0914 10.0914L8.71186 13.2173L7.3323 10.0914Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71195 5.92926L9.56388 7.85983L11.4945 8.71189L9.56388 9.56389L8.71195 11.4945L7.85988 9.56389L5.92932 8.71189L7.85988 7.85983L8.71195 5.92926Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/AW.8a4fb56e.svg";
export { ForwardRef as ReactComponent };